import React from 'react'

function Disadvantages() {
    return (
        <div className='disadvantages' id='disadvantages id'>
            <p className='header-two'>Disadvantages of Bad Posture</p>
            <p className='paragraph-two'>
                1. Misalign your musculoskeletal system.
                <br/>
                2. Wear away at your spine, making it more fragile and prone to injury.
                <br/>
                3. Cause neck, shoulder, and back pain.
                Decrease your flexibility.
                <br/>
                4. Affect how well your joints move.
                <br/>
                5. Affect your balance and increase your risk of falling.
                <br/>
                6. Make it harder to digest your food.
                <br/>
                7. Make it harder to breathe.
            </p>
        </div>
    )
}

export default Disadvantages
